import { render, staticRenderFns } from "./custBookingTx.vue?vue&type=template&id=46b75922&scoped=true"
import script from "./custBookingTx.vue?vue&type=script&lang=js"
export * from "./custBookingTx.vue?vue&type=script&lang=js"
import style0 from "./custBookingTx.vue?vue&type=style&index=0&id=46b75922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b75922",
  null
  
)

export default component.exports